import { defineMessages } from 'react-intl'

export default defineMessages({
  name: {
    id: 'components.OTP.name',
    defaultMessage: 'Validation Code',
    description: '请修改',
  },
  send: {
    id: 'components.OTP.send',
    defaultMessage: 'Send',
    description: '请修改',
  },
  resend: {
    id: 'components.OTP.resend',
    defaultMessage: 'Resend',
    description: '请修改',
  },
})
